import { render, staticRenderFns } from "./AddSbujkSearch.vue?vue&type=template&id=1219d070&scoped=true&"
import script from "./AddSbujkSearch.vue?vue&type=script&lang=js&"
export * from "./AddSbujkSearch.vue?vue&type=script&lang=js&"
import style0 from "./AddSbujkSearch.vue?vue&type=style&index=0&id=1219d070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1219d070",
  null
  
)

export default component.exports